module.exports = __webpack_public_path__ + "img/codicon:activate-breakpoints.656da0df.svg";